import request from '@/utils/request'

// 查询系统配置（公开接口）
export function getSystemConfig() {
  return request({
    url: '/front/systemConfig',
    method: 'get'
  })
}
